import React from "react"
import {
  eventsItemImg,
  eventsItemDate,
  eventsItemDateFrom,
  eventsItemDateTo,
  eventsItemTaxo,
  eventsItemTitle,
  eventsItemResume,
  editButton,
  eventsItemRecurrence,
} from "../styles/listEvents.module.scss"
import {
  EventsItemDate,
  EventsItemTaxo,
  EventsItemImg,
  EventItemRecurrence,
} from "./styled-components/evenement-item-styled"
import TransitionFade from "../../../components/transition-fade"
import SummaryTransformer from "../../../components/Transformers/summary-transformer"
import NonStretchedImage from "../../../components/Image/non-stretched-image"
import PropTypes from "prop-types"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

const EvenementItem = ({ evenement, taxoChoisie }) => {
  const characterLength = 200
  if (
    taxoChoisie === "" &&
    evenement.relationships.field_taxonomie_thematique?.length > 0
  ) {
    taxoChoisie = evenement.relationships.field_taxonomie_thematique[0].name
  }
  return (
    <>
      <EditButton
        link={"/node/" + evenement.drupal_internal__nid + "/edit"}
        addedClass={editButton}
      />
      <TransitionFade link={evenement.path.alias}>
        <EventsItemImg className={eventsItemImg}>
          {evenement.relationships.field_image_event?.localFile && (
            <NonStretchedImage
              {...evenement.relationships.field_image_event.localFile}
              ariaHidden={true}
            />
          )}
        </EventsItemImg>
        <EventsItemDate className={eventsItemDate}>
          {!evenement.fields.formatted_field_date_de_fin ? (
            <span className={eventsItemDateFrom}>
              Le {evenement.fields.formatted_field_date_de_debut}
            </span>
          ) : (
            <>
              <span className={eventsItemDateFrom}>
                Du {evenement.fields.formatted_field_date_de_debut}
              </span>
              <span className={eventsItemDateTo}>
                {" "}
                au {evenement.fields.formatted_field_date_de_fin}
              </span>
            </>
          )}
          {evenement.field_evenement_recurrent && (
            <EventItemRecurrence className={eventsItemRecurrence}>
              Récurrent
            </EventItemRecurrence>
          )}
        </EventsItemDate>
        <EventsItemTaxo className={eventsItemTaxo}>
          <p>Thématique: </p>
          <p>{taxoChoisie}</p>
        </EventsItemTaxo>
        <h4 className={eventsItemTitle}>{evenement.title}</h4>
        {evenement.body && (
          <p
            className={eventsItemResume}
            dangerouslySetInnerHTML={{
              __html: SummaryTransformer(evenement.body, characterLength),
            }}
          />
        )}
      </TransitionFade>
    </>
  )
}

EvenementItem.propTypes = {
  evenement: PropTypes.object.isRequired,
  taxoChoisie: PropTypes.string.isRequired,
}

export default EvenementItem
